import { Failure } from "./Failure";
import { Challenge } from "@cleverbase-trust-drivers/shared/Domain";

export interface Initialized {
  type: "Initialized";
  relyingPartyName: string;
  identityAttributes: Array<string>;
  title: string;
  logoUri?: string | undefined;
  contextText?: string | undefined;
  processId?: string | undefined;
}

export interface AuthenticationRequested {
  type: "AuthenticationRequested";
  ckChallenge: Challenge;
}
export interface Authenticated {
  type: "Authenticated";
  showNonPkioAlert: boolean;
}
export interface ConsentRequested {
  type: "ConsentRequested";
}
export interface ConsentGranted {
  type: "ConsentGranted";
  redirectUri: string;
}
export interface Failed {
  type: "Failed";
  failure: Failure;
  maybeRedirectUri?: string;
}

export function isIdentificationState(obj: any): obj is IdentificationState {
  const casted = obj as Partial<IdentificationState>;

  switch (casted["type"]) {
    case "Initialized":
    case "AuthenticationRequested":
    case "Authenticated":
    case "ConsentRequested":
    case "ConsentGranted":
    case "Failed":
      return true;
  }
  return false;
}

export type IdentificationState =
  | Initialized
  | AuthenticationRequested
  | Authenticated
  | ConsentRequested
  | ConsentGranted
  | Failed;

export type IdentificationFlow = {
  initialized?: Initialized;
  authenticationRequested?: AuthenticationRequested;
  authenticated?: Authenticated;
  consentRequested?: ConsentRequested;
  consentGranted?: ConsentGranted;
  failed?: Failed;
};
